'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _lawCategories = require('../actions/lawCategories');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchLawCategories),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchLawCategory),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(createLawCategory),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(editLawCategory),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(deleteLawCategory),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchLawCategoriesRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(fetchLawCategoryRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(createLawCategoryRequest),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(editLawCategoryRequest),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(deleteLawCategoryRequest);

function fetchLawCategories() {
    var response;
    return regeneratorRuntime.wrap(function fetchLawCategories$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/lawcategories');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_lawCategories.actionCreators.fetchLawCategoriesSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_lawCategories.actionCreators.fetchLawCategoriesFailed(_context.t0));

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchLawCategory(_ref) {
    var id = _ref.id;
    var response;
    return regeneratorRuntime.wrap(function fetchLawCategory$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/lawcategories/' + id);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_lawCategories.actionCreators.fetchLawCategorySucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_lawCategories.actionCreators.fetchLawCategoryFailed(_context2.t0));

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function createLawCategory(_ref2) {
    var lawCategory = _ref2.lawCategory,
        onSuccess = _ref2.onSuccess;
    var response;
    return regeneratorRuntime.wrap(function createLawCategory$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/lawcategories', lawCategory);

                case 3:
                    response = _context3.sent;
                    _context3.next = 6;
                    return (0, _effects.put)(_lawCategories.actionCreators.createLawCategorySucceeded(response.data));

                case 6:
                    if (onSuccess) onSuccess();
                    _context3.next = 13;
                    break;

                case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 13;
                    return (0, _effects.put)(_lawCategories.actionCreators.createLawCategoryFailed(_context3.t0.response ? _context3.t0.response.data : _context3.t0));

                case 13:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 9]]);
}

function editLawCategory(_ref3) {
    var lawCategory = _ref3.lawCategory,
        onSuccess = _ref3.onSuccess;
    var response;
    return regeneratorRuntime.wrap(function editLawCategory$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/lawcategories/' + lawCategory.id, lawCategory);

                case 3:
                    response = _context4.sent;
                    _context4.next = 6;
                    return (0, _effects.put)(_lawCategories.actionCreators.editLawCategorySucceeded(response.data));

                case 6:
                    if (onSuccess) onSuccess();
                    _context4.next = 13;
                    break;

                case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 13;
                    return (0, _effects.put)(_lawCategories.actionCreators.editLawCategoryFailed(_context4.t0.response ? _context4.t0.response.data : _context4.t0));

                case 13:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 9]]);
}

function deleteLawCategory(_ref4) {
    var id = _ref4.id,
        onSuccess = _ref4.onSuccess;
    return regeneratorRuntime.wrap(function deleteLawCategory$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.prev = 0;
                    _context5.next = 3;
                    return (0, _effects.call)(_api.request, 'delete', '/lawcategories/' + id);

                case 3:
                    _context5.next = 5;
                    return (0, _effects.put)(_lawCategories.actionCreators.deleteLawCategorySucceeded(id));

                case 5:
                    if (onSuccess) onSuccess();
                    _context5.next = 12;
                    break;

                case 8:
                    _context5.prev = 8;
                    _context5.t0 = _context5['catch'](0);
                    _context5.next = 12;
                    return (0, _effects.put)(_lawCategories.actionCreators.deleteLawCategoryFailed(_context5.t0.response ? _context5.t0.response.data : _context5.t0));

                case 12:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[0, 8]]);
}

function fetchLawCategoriesRequest() {
    return regeneratorRuntime.wrap(function fetchLawCategoriesRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_lawCategories.actionTypes.FETCH_LAW_CATEGORIES_REQUEST, fetchLawCategories);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function fetchLawCategoryRequest() {
    return regeneratorRuntime.wrap(function fetchLawCategoryRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_lawCategories.actionTypes.FETCH_LAW_CATEGORY_REQUEST, fetchLawCategory);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function createLawCategoryRequest() {
    return regeneratorRuntime.wrap(function createLawCategoryRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_lawCategories.actionTypes.CREATE_LAW_CATEGORY_REQUEST, createLawCategory);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function editLawCategoryRequest() {
    return regeneratorRuntime.wrap(function editLawCategoryRequest$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.takeLatest)(_lawCategories.actionTypes.EDIT_LAW_CATEGORY_REQUEST, editLawCategory);

                case 2:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function deleteLawCategoryRequest() {
    return regeneratorRuntime.wrap(function deleteLawCategoryRequest$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(_lawCategories.actionTypes.DELETE_LAW_CATEGORY_REQUEST, deleteLawCategory);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

exports.default = [fetchLawCategoriesRequest, fetchLawCategoryRequest, createLawCategoryRequest, editLawCategoryRequest, deleteLawCategoryRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/lawCategories.js
// module id = 2223
// module chunks = 0